import React from 'react';
import { Globe, Mail, Phone, MapPin } from 'lucide-react';
import '../footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-company">
            <div className="footer-logo">
              <Globe size={32} />
              <h3 className="footer-logo-text">
                <span className="footer-logo-accent">OIG</span>Hosting
              </h3>
            </div>
            <p className="footer-description">
              Professional web solutions and reliable hosting services for businesses of all sizes.
            </p>
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <Mail size={16} />
                <span>oighosting29@gmail.com</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <span>(312) 597-7347</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>Serving clients worldwide</span>
              </div>
            </div>
          </div>

          {/* Website Services */}
          <div className="footer-section">
            <h4>Website Services</h4>
            <ul>
              <li>
                <button
                  onClick={() => scrollToSection('website-packages')}
                  className="footer-link"
                >
                  Basic Website Package
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('website-packages')}
                  className="footer-link"
                >
                  Professional Website
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('website-packages')}
                  className="footer-link"
                >
                  Premium Website
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="footer-link"
                >
                  Custom Solutions
                </button>
              </li>
            </ul>
          </div>

          {/* Hosting Services */}
          <div className="footer-section">
            <h4>Hosting Plans</h4>
            <ul>
              <li>
                <button
                  onClick={() => scrollToSection('hosting-plans')}
                  className="footer-link"
                >
                  Starter Hosting
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('hosting-plans')}
                  className="footer-link"
                >
                  Business Hosting
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('hosting-plans')}
                  className="footer-link"
                >
                  Pro Hosting
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="footer-link"
                >
                  Enterprise Solutions
                </button>
              </li>
            </ul>
          </div>

          {/* Support & Company */}
          {/* <div className="footer-section">
            <h4>Support & Company</h4>
            <ul>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="footer-link"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Support Center
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="footer-link">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div> */}
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2025 OIGHosting. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <button
              onClick={() => scrollToSection('hero')}
              className="footer-bottom-link"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('website-packages')}
              className="footer-bottom-link"
            >
              Website Packages
            </button>
            <button
              onClick={() => scrollToSection('hosting-plans')}
              className="footer-bottom-link"
            >
              Hosting Plans
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="footer-bottom-link"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;